import TextImage from "../../../UI/TextImage/TextImage";
import mainImage from "../../../../assets/HomePage/ExclusiveMembershipImg.png";

const ExclusiveMembership = (props) => {
  return (
    <TextImage
      imageThenText={false}
      header={"The Mastermind."}
      paragraph={`Navigate and accelerate your journey as a SaaS Founder in a hyper-curated peer group of 4-8 members, facilitated by an executive coach.`}
      src={mainImage}
      alt={"Mastermind"}
      maxWidth={{ maxWidth: "250px" }}
    />
  );
};

export default ExclusiveMembership;
